import { useCallback, useState } from 'react'

import type { AdditionalCostType } from '@api'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import type { DialogProps } from '@/dialogs/types'

interface Props extends DialogProps {
  data: AdditionalCostType
  onSubmit: (id: number) => Promise<void>
}

export const AccountingAdditionalCostDeleteDialog = ({
  isOpen,
  onClose,
  data,
  onSubmit,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const handleClick = useCallback(async () => {
    setIsLoading(true)
    try {
      await onSubmit(data.id!)
      onClose()
    } catch (error) {
      /* empty */
    } finally {
      setIsLoading(false)
    }
  }, [data.id, onClose, onSubmit])

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Delete {data?.name}?</Dialog.Title>
        <Dialog.Description className="text-center">
          Are you sure you want to delete the cost?
        </Dialog.Description>
      </Dialog.Header>
      <Dialog.ClosableFooter
        className="mt-6"
        onClose={onClose}
      >
        <Button
          variant="destructive"
          onClick={handleClick}
          isLoading={isLoading}
        >
          Remove
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
